function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30 7.499C30 9.984 32.014 12 34.498 12 36.987 12 39 9.984 39 7.499 39 5.016 36.987 3 34.498 3 32.014 3 30 5.016 30 7.499zM33.34 31.508l-5.402-4.788 4.67-9.234-1.416-4.242-2.507-1.395-8.165-1.782-1.633.256-6.929 4.972 2.331 3.234 5.994-4.31 4.409 1.4-4.934 8.042 1.411 5.885 7.586 4.68-1.706 8.784 4.908.952 2.027-10.672L33.34 31.508z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5 41A2.5 2.5 0 1 0 29.5 46 2.5 2.5 0 1 0 29.5 41zM13 15A2 2 0 1 0 13 19 2 2 0 1 0 13 15zM20 10A2 2 0 1 0 20 14 2 2 0 1 0 20 10zM30 13A3 3 0 1 0 30 19 3 3 0 1 0 30 13zM32 31A2 2 0 1 0 32 35 2 2 0 1 0 32 31zM23 22A4 4 0 1 0 23 30 4 4 0 1 0 23 22zM42 23h-6l-1.787-4.257-2.241 4.429 1.209 2.666.012.008C33.513 26.526 34.199 27 35 27h7c1.105 0 2-.895 2-2C44 23.895 43.105 23 42 23zM20.048 31.203c-1.144-.648-2.016-1.633-2.53-2.788L15.242 32H7.5C6.119 32 5 33.119 5 34.5 5 35.881 6.119 37 7.5 37h8.432c1.297 0 2.514-.629 3.264-1.687l2.285-3.224C20.654 31.578 20.055 31.208 20.048 31.203z"
});

function SvgRunning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.984ead19.svg";
export { ForwardRef as ReactComponent };